<script>
/**
 * Show vouchers based on category and possibly also a milestone
 */
import VoucherService from "@/services/VoucherService";
import { mapGetters } from "vuex";

export default {
    props: {
        projectId: {},
        voucherCategory: {
            description: "ID of the category."
        },
        projectMilestone: {
            description:
                "Optional project milestone. If not set - everything within a given category is being shown, i.e. across all matching milestones"
        },
        yearMonth: {
            description:
                "Month year in format YYYY-MM to limit search to a given month only",
            default: ""
        }
    },
    data() {
        return {
            loading: true,
            vouchers: [],
            view: "main",
            ctxVoucher: "",
            pdfLoad: false,
            BK: false
        };
    },
    computed: {
        ...mapGetters("auth", ["getAclMap"]),
        visibleVouchers() {
            if (this.BK == false) {
                return this.vouchers.filter(v => v.category_function != 2);
            } else {
                return this.vouchers;
            }
        }
    },
    async created() {
        this.BK = this.$aclCan(this.$ACL.CUSTOM_PLANNING_BK_SH_NC);
        await this.fetchData();
        this.loading = false;
    },
    methods: {
        async fetchData() {
            try {
                let params = {};
                if (parseInt(this.projectMilestone) > 0) {
                    params.project_milestone_id = this.projectMilestone;
                }

                if (this.yearMonth !== "") {
                    params.yearMonth = this.yearMonth;
                }

                const { data } = await VoucherService.GET_listAllocated(
                    this.projectId,
                    this.voucherCategory,
                    params
                );

                this.vouchers = data.data;
            } catch (e) {
                console.log("fe e", e);
            }
        },
        showPdf(id) {
            this.pdfLoad = true;
            this.ctxVoucher = id;
            this.view = "pdf";
        }
    }
};
</script>

<template>
    <div class="v-list-vouchers">
        <template v-if="view === 'main'">
            <v-loader :loading="loading" v-if="loading" />
            <template v-else>
                <v-table class="table table-mg table-sm">
                    <v-thead>
                        <v-tr>
                            <v-th>{{ $t("vouchers.tbl_hdr_date") }}</v-th>
                            <v-th>{{
                                $t("vouchers.tbl_hdr_description")
                            }}</v-th>
                            <v-th class="text-right">{{
                                $t("vouchers.tbl_hdr_invoice_amount")
                            }}</v-th>
                            <v-th>{{ $t("vouchers.tbl_hdr_milestone") }}</v-th>
                            <v-th class="text-right">{{
                                $t("vouchers.tbl_hdr_milestone_amount")
                            }}</v-th>
                            <v-th class="text-right">{{
                                $t("vouchers.tbl_hdr_category_amount")
                            }}</v-th>
                            <v-th></v-th>
                        </v-tr>
                    </v-thead>
                    <v-tbody>
                        <v-tr
                            v-for="(v, idx) in visibleVouchers"
                            :key="idx"
                            :class="`category-function-${v.category_function}`"
                        >
                            <v-td
                                >{{
                                    $d(
                                        new Date(v.voucher.voucher_date),
                                        "short"
                                    )
                                }}
                                <div class="small text-muted">
                                    #{{ v.voucher.id }}
                                </div></v-td
                            >
                            <v-td>
                                {{ v.voucher.description }}
                            </v-td>
                            <v-td class="text-right">{{
                                $n(v.voucher.amount, {
                                    style: "currency",
                                    currency: v.voucher.currency,
                                    currencyDisplay: "code"
                                })
                            }}</v-td>
                            <v-td
                                >M{{ v.project_milestone_m_ident }}
                                <div class="small text-muted">
                                    {{ v.project_milestone_name }}
                                </div>
                            </v-td>
                            <v-td class="text-right">
                                {{
                                    $n(v.milestone_amount, {
                                        style: "currency",
                                        currency: v.milestone_amount_currency,
                                        currencyDisplay: "code"
                                    })
                                }}
                            </v-td>

                            <v-td class="text-right"
                                ><span class="cat-amount">{{
                                    $n(v.category_amount, {
                                        style: "currency",
                                        currency: v.category_amount_currency,
                                        currencyDisplay: "code"
                                    })
                                }}</span>

                                <div class="small text-muted">
                                    {{ v.category_name }}
                                </div>
                            </v-td>
                            <v-td class="text-center"
                                ><base-button
                                    size="sm"
                                    :disabled="!v.voucher.has_doc"
                                    type="primary"
                                    @click="showPdf(v.voucher.id)"
                                    ><i
                                        class="far fa-file-pdf"
                                    ></i></base-button
                            ></v-td>
                        </v-tr>
                    </v-tbody>
                </v-table>
            </template>
        </template>
        <template v-else-if="view === 'pdf'">
            <div class="mb-4">
                <base-button @click="view = 'main'" type="primary"
                    ><i class="far fa-arrow-left"></i>
                    {{ $t("vouchers.go_back") }}</base-button
                >
            </div>

            <v-loader :loading="pdfLoad" v-if="pdfLoad" />
            <iframe
                id="pdfViewerN"
                :src="`/v1/vouchers/fetch-doc-pdf/${ctxVoucher}`"
                frameborder="0"
                @load="pdfLoad = false"
            ></iframe>
        </template>
    </div>
</template>

<style lang="scss">
#pdfViewerN {
    width: 100%;
    min-height: 700px;
    height: 100%;
    border: none; /* No border around the iframe */
}

.category-function {
    &-2 {
        td {
            color: $gray-600 !important;
        }

        .cat-amount {
            text-decoration: line-through;
        }
    }
}
</style>
